export default {
    disposition: {
        title: "DISPOSITION",

        report: {
            title   : "GBU/TZB Dokumente exportieren",
            create  : {
                date: "Erstelldatum",
                mode: {
                    allDocuments    : "alle Begehungen",
                    newDocuments    : "alle Begehungen ohne Dokumente",
                    currentDocuments: "alle Begehungen mit Dokumenten",
                    dateDocuments   : "alle Begehungen mit Erstelldatum ..."
                },

                waiting: "Dokumente werden erstellt ...",
                button : "Erstellen"
            },

            download: {
                button: "Download",
                all   : "alle bereits erstellten",
                inProcess: "Download nicht möglich, Dokumente werden gerade erstellt",
            },
        },

        status: {
            inProcess: "in Bearbeitung",
            done     : "abgeschlossen"
        },

        map: {
            toolkit: "Karte",
            center : "neu zentrieren"
        },

        modes: {
            allOrders : "Alle Begehungen anzeigen",
            assign    : "Auftrag bearbeiten",
            dispatch  : "Gutachter zuordnen",
            map       : "Karte anzeigen",
        },

        order: {
            title   : "Auftrag",
            status  : "Status",
            no      : "Auftragsnummer",
            comment : "Bemerkungen",
            color   : "Farbe",
            customer: "Kunde",
            create  : "neuer Auftrag",
            assign  : "Die Anlage wurde dem Auftrag hinzugefügt",
            disolved: "Die Anlage wurde aus dem Auftrag entfernt",
            filter: {
                closed: "abgeschlossene Aufträge anzeigen"
            },
            refresh : "Aktualisieren",
            prioritize: {
                on : "Aufträge priorisieren",
                off: "Priorisierung beenden"
            },
            scope   : {
                title    : "Umfang",
                elevator : "Anlagendaten",
                lgs      : "Liftguardian",
                sticker  : "QR Codes",
                condition: "TZB",
                audit    : "GBU",
                esg      : "ESG",
                show     : "Auftragumfang anzeigen",
                hide     : "Auftragumfang ausblenden"
            },

            unit: {
                title  : "Begehung",
                edit   : "Anlage bearbeiten",
                refresh: "Begehung aktualisieren",
                refreshDone: "Die Begehnung wurde aktualisiert"
            },

            remove: {
                tooltip: "Auftrag löschen",
                query  : "Auftrag löschen?",
                text   : "Soll der Auftrag gelöscht werden? Mit <b>JA</b> wird der Auftrag gelöscht.",
                done   : "Die Auftrag wurde gelöscht."
            },

            edit  : "Auftrag bearbeiten",

            reports: {
                documents: {
                    loading: "Das Dokumentenarchiv für den Auftrag wird erstellt ..."
                }
            },

        },


        assignment: {
            exists: {
                title: "Anlage wird schon verwendet",
                message: "Die Anlage ist bereits beim Auftrag <span style='color:red'>{0}</span> zur Begehung eingeplant."
            },

            multiple: {
                title: "Anlage wird mehrfach verwendet",
                message: "Die Anlage {0} ist mehrfach zur Begehung eingeplant."
            },
        },

        inspection: {
            // device type of the app and conflicts with the site type (HCIT-943)
            deviceType: {
                ELEVATOR : "Aufzug",
                ESCALATOR: "Fahrtreppe",
                conflict: {
                    title    : "Typ-Konflikt",
                    hint     : "Anlagentyp in den Stammdaten prüfen und korrigieren oder beim Gutachter nachfragen; danach „Erneut prüfen“.",
                    unit     : "Anlage öffnen",
                    check    : "Erneut prüfen",
                    unknown  : "Der in der App gewählte Anlagentyp passt nicht zur Anlage.",
                    stillOpen: "Der Typ-Konflikt besteht weiterhin.",
                    resolved : "Der Typ-Konflikt ist behoben.",
                    filter   : "Nur Begehungen mit Typ-Konflikt",
                },
                check: {
                    failed: {
                        title  : "Prüfung nicht möglich",
                        message: "Der Anlagentyp konnte nicht geprüft werden (Stammdaten nicht erreichbar). Bitte später erneut versuchen.",
                    },
                },
                // InspectionMessage of disposition-svc when the type is changed in the app after its transfer (HCIT-1190)
                changedAfterTransfer: {
                    title  : "Anlagentyp geändert",
                    message: "Der Anlagentyp wurde nach der Übertragung in der App geändert. Bitte Anlagentyp und Stammdaten prüfen.",
                },
            },
            edit      : "Anlage bearbeiten",
            id        : "HC-ID - Fabriknummer",
            hcid      : "HC_ID",
            no        : "Fabriknummer",
            date      : "Datum der Begehung",
            zip       : "PLZ",
            city      : "Ort",
            street    : "Straße",
            created   : "Erstellt am",
            lastUpload: "Letzter Upload am",
            download  : "Download am",
            transfer  : "Übertragen",
            contact: {
                na: "kein Ansprechpartner"
            },

            assigned: "Die Anlage wurde zur Begehung dem Auftrag zugeordnet ",
            assignAll: {
                success: "Die Anlagen wurden zur Begehung dem Auftrag eingeplant ",
                query  : "Alle Anlagen der Adresse einplanen?",
                text   : "<p>Es wird für alle Anlagen der Adresse:</p><p class='success--text'><b>{0} {1}, {2}</b><br>{3}</p><p>eine Begehung für den Auftrag <b>{4}</b> eingeplant.</p><p class='mb-0'>Mit <b>JA</b> werden die Einplanungen und durchgeführt.</p>"
            },

            remove: {
                query: "Begehnung entfernen?",
                text : "Soll die Begehung wirklich aus dem Auftrag entfernt werden? Alle bisher erfassten Daten gehen hierbei verloren. Mit <b>JA</b> wird die Begehung entfernt.",
                done : "Die Begehung wurde aus dem Auftrag entfernt."
            },

            removeAll: {
                success: "Die Anlagen wurden aus dem Auftrag entfernt ",
                query  : "Alle Anlagen der Adresse entfernen?",
                text   : "<p>Es werden alle Begehungen der Adresse:</p><p class='error--text'><b>{0} {1}, {2}</b><br>{3}</p><p>die noch nicht auf ein Mobile geladen wurden aus dem Auftrag <b>{4}</b> entfernt.</p><p class='mb-0'>Mit <b>JA</b> werden die Begehungen entfernt.</p>"
            },

            reopen: {
                tooltip: "Erneut bearbeiten",
                query  : "Erneut bearbeiten?",
                text   : "Mit <b>JA</b> wird die Begehung erneut zur Bearbeitung geöffnet. Die Begehung kann anschließend auch wieder in die APP geladen werden."
            },

            dispatched: "Die Anlage {0} wurde {1} zugeordnet",
            dispatchAll: {
                success: "Die Anlagen wurden {0} zugeordnet ",
                query  : "Alle Anlagen der Adresse zuordnen?",
                text   : "<p>Es werden alle Anlagen der Adresse:</p><p><b>{0} {1}, {2}</b><br>{3}</p><p>{4} zur Behehung zugeordnet.</p><p class='mb-0'>Mit <b>JA</b> werden die Zuordnungen durchgeführt.</p>"
            },

            releaseAll: {
                success: "Die Anlagen können nun neu zugeordnet werden",
                query  : "Alle Gutachter der Begehungen zur Adresse entfernen?",
                text   : "<p>Es werden die Gutachter aller Begehungen der Adresse:</p><p><b>{0} {1}, {2}</b><br>{3}</p><p>die noch nicht auf ein Mobile geladen wurden aus dem Auftrag <b>{4}</b> entfernt.</p><p class='mb-0'>Mit <b>JA</b> werden die Gutachter entfernt.</p>"
            },

            technician: {
                label: "Gutachter",
                change: {
                    query: "Gutachter ändern?",
                    text : "<p>Der Gutachter wurde von <b>{0}</b> auf <b>{1}</b> geändert.</p><p><span style='color:red'>Dadurch wird die Begehung auf der APP von <b>{0}</b> mit dem nächsten Download gelöscht</span>.</p><p>Mit <b>JA</b> wird die Änderung durchgeführt.</p>",
                },
                removed: {
                    query: "Gutachter löschen?",
                    text : "<p>Der Gutachter <b>{0}</b> wurde gelöscht.</p><p><span style='color:red'>Dadurch wird die Begehung auf der APP von <b>{0}</b> mit dem nächsten Download gelöscht</span>.</p><p>Mit <b>JA</b> wird die Änderung durchgeführt.</p>",
                },

                exists: {
                    title: "Gutachter ist bereits zugeordnet",
                    message: "Der Begehung wurde inzwischen dem Gutachter <span style='color:red'>{0}</span> zugeordnet.<br><span style='color:red'>Bitte aktualisiere Deine Ansicht!</span>"
                },

                released: {
                    title: "Die Begehung wurde freigegeben",
                    message: "Der Gutachter der Begehung wurde inzwischen entfernt.<br><span style='color:red'>Bitte aktualisiere Deine Ansicht!</span>"
                },

                assigned: "Der Gutachter wurde der Begehung zugeordnet",
            },

            comment: {
                title: null,
                message: "Bitte beachte die Bemerkungen zu der Begehung!</span>"
            },

            tooltip   : {
                create: "Neue Anlage erstellen",
                assign: "Bestehende Anlage zuordnen",
                search: "Erneut suchen",
            },
        },

        book: {
            menu : "Prüfbuch",
            title: "Prüfbuch"
        },

        conditions: {
            menu: "TZB",
            title: "TZB",
        },

        sticker: {
            menu: "QR Codes",
            title: "QR Codes",
        },

        lgs: {
            menu: "Lift Guardian",
            title: "Lift Guardian",
        },

        unit: {
            refresh    : "Begehung aktualisieren",
            refreshDone: "Die Begehung wurde aktualisiert.",
            edit       : "Begehung bearbeiten",
            menu       : "Anlagendaten",
            created    : "NEU",
            create     : {
                query: "Neue Anlage?",
                text: "<p>Soll für die Begehung eine neue Anlage erstellt werden? Mit <b>JA</b> wird eine neue Anlage erstellt und der Begehung zugeordnet.</p><p class='mb-0'>Mit dem nächsten Upload wird diese Anlage auch in die APP übernommen.</p>"
            },
            assign: {
                query: "Anlage zuordnen?",
                text: "<p>Soll die Anlage der Begehung zugeordnet werden? Mit <b>JA</b> wird die Anlage der Begehung zugeordent.</p><p class='mb-0'>Mit dem nächsten Upload in der APP wird diese Anlage auch in die APP übernommen.</p>"
            },
            ve         : "VE",
            ve2        : "VE2",
            ve3        : "VE3",
        },

        audit: {
            measure: "Maßnahme",
            notes: "Notizen",

            GBU: {
                menu      : "GBU",
                title     : "Gefährdungsbeurteilung",
                facilities: "Externe Sicherheitseinrichtungen",
                hazards   : "Gefahren"
            },

            ESG: {
                menu: "ESG",
                title: "Environmental, Social and Governance",
            },
        },

        images: {
            menu: "Fotos",
            title: "Fotos",
        },

        // message of the escalator TZB transfer (HCIT-979)
        condition: {
            escalator: {
                unit: {
                    mismatch: {
                        title  : "TZB Fahrtreppe",
                        message: "Der Fahrtreppen-TZB wurde nicht übertragen: Die Anlage ist in den Stammdaten keine Fahrtreppe.",
                    },
                },
            },
        },
    },

    // messages of the site type correction (HCIT-912/943); the only "masterdata" root of the i18n files
    masterdata: {
        site: {
            deviceType: {
                conflict: {
                    title  : "Typ-Konflikt",
                    message: "In der App wurde „{0}“ gewählt, die Anlage ist als „{1}“ geführt.",
                },
            },
            notfound: {
                title  : "Anlage nicht gefunden",
                message: "Die Anlage {0} wurde in den Stammdaten nicht gefunden; der Anlagentyp wurde nicht übernommen.",
            },
        },
    },
}